<template>
    <div v-if="bizAuth.assignLandlordAndAgent.hasRight" class="page-setting has-bc parent-frame batch-policy" :class="{'fixed': listIsFixed}">
        <all-instead-landlord></all-instead-landlord>
        <all-instead-group-and-sales></all-instead-group-and-sales>
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}({{batchListTotal}})</h1>
            <div class="btn-group" v-if="hasSeletedHouse">
                <div class="border-button instead" @click="allLandlordInstead">
                    所有房東替換為
                </div>
                <div class="default-button instead" @click="allSalesInstead">
                    所有業務替換為
                </div>
            </div>
        </div>
        <batch-dispatch-comp></batch-dispatch-comp>
    </div>
</template>
<script>
import batchDispatchComp from '@/components/bussiness/mgtCategory/houseMgt/batchDispatch/batchDispatchComp.vue';
import allInsteadLandlord from '@/components/bussiness/widges/modals/allInsteadLandlord.vue';
import allInsteadGroupAndSales from '@/components/bussiness/widges/modals/allInsteadGroupAndSales.vue';

import { mapGetters } from 'vuex'


export default {
    data () {
        return {
            listIsFixed: false
        }
    },
    mounted () {
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
        window.addEventListener('scroll', this.handleScroll);
        this.$store.dispatch('getBizDispatchOrgGroupList')
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        'bizAuth.assignLandlordAndAgent.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
            }else{
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
        allLandlordInstead: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizAllInsteadLandlord'})
        },
        allSalesInstead: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizAllInsteadGroupAndSales'})
        },
    },
    computed: {
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
            hasSeletedHouse: 'GET_BIZ_BATCH_DISPATCH_HAS_SELECTED_HOUSE',
            batchListTotal: 'GET_BIZ_BATCH_DISPATCH_LIST_TOTAL'
        })
    },
    components: {
        batchDispatchComp,
        allInsteadLandlord,
        allInsteadGroupAndSales
    }
}
</script>
<style lang="scss">
    .batch-policy{
        &.page-setting.fixed .table-list .table-list-title {
            width: 819px;
        }
        .instead{
            width: 146px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/houseMgt/batchDispatch.vue